var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cube-wrapper"
  }, [_c("div", {
    staticClass: "cube cube1"
  }), _c("div", {
    staticClass: "cube cube2"
  }), _c("div", {
    staticClass: "cube cube3"
  }), _c("div", {
    staticClass: "cube cube4"
  }), _c("div", {
    staticClass: "cube cube5"
  }), _c("div", {
    staticClass: "cube cube6"
  }), _c("div", {
    staticClass: "cube cube7"
  }), _c("div", {
    staticClass: "cube cube8"
  }), _c("div", {
    staticClass: "cube cube9"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };